import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Registration, UserRegistration } from '~auth/model';
import { RegistrationService } from '~auth/services/registration.service';

@Injectable()
export class AORegistrationService extends RegistrationService {
  registerUser(user: UserRegistration): Observable<any> {
    return this.http.post(`${this.authConfig.aoUrl}/customers/registration`, user, { responseType: 'text' });
  }

  verifyUser(registration: Registration): Observable<any> {
    return this.http.put(`${this.authConfig.aoUrl}/customers/validationcodes/${registration.registrationCode}`, registration.username,
      { withCredentials: true });
  }

  forgotPassword(username: string): Observable<any> {
    return this.http.get(`${this.authConfig.aoUrl}/app/forgotpassword?email=${username}&url=uw.url`);
  }

  resetPassword(requestId: string, newPassword: string): Observable<any> {
    return this.http.put(`${this.authConfig.aoUrl}/app/forgotpassword?requestId=${requestId}&newPassword=${newPassword}`, null,
      { responseType: 'json' });
  }

  resendValidationCode(email) {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(`${this.authConfig.token}`), 'Content-Type': 'application/json' })
    return this.http.post(`${this.authConfig.aoUrl}/customers/validationcodes/`, email,
      { headers: headers, responseType: 'text', withCredentials: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/ao-registration.service.ts